<template>
<div>
<v-card>
  <v-card-title>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <!-- <v-text-field
        v-model="busqueda"
        append-icon="search"
        label="Buscar..."
        single-line
        hide-details
        color="blue darken-3"
      ></v-text-field> -->
  </v-card-title>
  <v-data-table
    :headers="cabeceras"
    :items="lista"
    class="elevation-1"
    :search="busqueda"
  >
    <template v-slot:top>
    </template>
    <template v-slot:body.prepend>
            <tr>
              <td v-for="columna in cabeceras" :key="columna.text">
                <v-text-field v-if="columna.filterable" v-model="columna.busqueda" type="text"></v-text-field>
                <!-- <v-text-field v-model="calories" type="number" label="Less than"></v-text-field> -->
              </td>
            </tr>
    </template>
    <!-- customizando una columna del data table -->
      <template v-slot:item.fecha_produccion="{ item }">
        <span>{{  moment(item.fecha_produccion).format('DD/MM/YYYY HH:mm') }}</span>
      </template>

      <template v-slot:item.muestra_color="{ item }">
        <v-chip
          :color="item.valor"
        >
        </v-chip>
      </template>
      <template v-slot:item.proveniente_de="{ item }">
        <span v-if="item.viene_del_jumbo!=null">
          Lote: {{item.proveniente_de.lote.nombre_lote}} Maxisaco: {{item.proveniente_de.nro_jumbo}}
        </span>
      </template>

        <!-- enviar jumbo a reproceso -->
          <template v-slot:item.enviar_reproceso="{ item }">
            <span>
              <v-btn v-if="item.repaso_jumbos_id==null" color="orange darken-3" fab small dark class="mr-2" @click="enviar_a_reproceso(item)">
                <v-icon small>arrow_right_alt</v-icon>
              </v-btn>
            </span>
        </template>
        <!-- enviar jumbo a reproceso -->

        <!-- restablecer jumbo de reproceso -->
        <template v-slot:item.restablecer_jumbo="{ item }">
            <span>
              <v-btn v-if="item.repaso_jumbos_id!=null" color="green darken-1" fab small dark class="mr-2" @click="restablecer_jumbo(item)">
                <v-icon small>autorenew</v-icon>
              </v-btn>
            </span>
        </template>
        <!-- restablecer jumbo de reproceso -->

        <!-- asignar usuarios a parametro detalle -->
        <template v-slot:item.asignar_usuarios="{ item }">
          <v-btn color="orange darken-2" fab small dark class="mr-2" @click="asignar_usuarios(item)">
                <v-icon small>person_add</v-icon>
          </v-btn>
        </template>
        <!-- asignar usuarios a parametro detalle -->

        <!-- configurar opciones de un parametro (de tipo select) -->
        <template v-slot:item.configurar_opciones_parametro="{ item }">
          <v-btn v-if="item.tipo == 'select'" color="orange darken-2" fab small dark class="mr-2" @click="configurar_opciones_parametro(item)">
                <v-icon small>list</v-icon>
          </v-btn>
        </template>
        <!-- configurar opciones de un parametro (de tipo select) -->

        <!-- indica si tiene o no alarma (parametro_detalles) -->
        <template v-slot:item.tiene_alarma="{ item }">
          
                <v-icon v-if="item.tiene_alarma" small>done</v-icon>
        </template>
        <!-- indica si tiene o no alarma (parametro_detalles) -->

    <!-- customizando una columna del data table -->

    <template v-slot:item.action="{ item }">
      <span v-for="accion in acciones" :key="accion.key">
        
        <!-- accion editar -->
        <span v-if="accion.key == 'editar'">
          <v-btn color="blue darken-3" fab small dark class="mr-2" @click="editarItem(item)">
            <v-icon small>edit</v-icon>
          </v-btn>
        </span>

        <!-- accion eliminar -->
        <span v-if="accion.key == 'eliminar'">
          <v-btn color="red darken-3" fab small dark @click="eliminarItem(item)">
            <v-icon small>delete</v-icon>
          </v-btn>
        </span>

      </span>
    </template>

    <!-- accion cerrar lote -->
    <template v-slot:item.cerrar_lote="{ item }">
          <v-btn v-if="item.cerrado == 0" color="deep-orange darken-1" fab small dark class="mr-2" @click="cerrarLote(item)">
            <v-icon small>not_interested</v-icon>
          </v-btn>
    </template>
    <!-- accion cerrar lote -->

    <template v-slot:no-data>
      <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      No existen Registros
    </template>
  </v-data-table>
</v-card>
  
</div>
  
</template>
<script>
  export default {
    data: () => ({
      cabeceras:[],
      lista:[],
      acciones:[],
      busqueda:'',
    }),

    computed: {
    },

    watch: {
    },

    created () {
      
    },
    beforeDestroy() {
      Event.$off('inicializar_tabla');
    },
    mounted(){
      Event.$on('inicializar_tabla',(cabeceras,lista,acciones)=>{
        this.cabeceras = cabeceras;

        /*configuracion del filtro por cada cabecera (columna de la tabla) */
        this.cabeceras.forEach(cabecera => {
            //se agrego (cabecera.busqueda = '') para evitar error undefined
            if(cabecera.filterable){
              cabecera.busqueda = '';
              cabecera.filter = valor => { 
                  return ( valor + '' ).toLowerCase().includes( cabecera.busqueda.toLowerCase() ) 
              }
            }
        });
        // this.cabeceras[0]['filter'] = f => { 
        //   return ( f + '' ).toLowerCase().includes( this.cabeceras[0].busqueda.toLowerCase() ) 
        // }
        this.lista = lista;
        this.acciones = acciones;
        console.log('cabeceras',this.cabeceras);
        console.log('lista recibida en data table',lista);
      });
    },

    methods: {

      editarItem (item) {
        console.log('editando item...',item);
        this.$emit('editar',item);
      },

      eliminarItem (item) {
        const index = this.desserts.indexOf(item);
        confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1);
      },

      cerrarLote(item){
        this.$emit('cerrar_lote',item);
      },

      enviar_a_reproceso(item){
        this.$emit('enviar_jumbo_a_reproceso',item);
      },

      restablecer_jumbo(item){
        // console.log('restableciendooo',item);
        this.$emit('restablecer_jumbo',item);
      },

      asignar_usuarios(item){
        this.$emit('asignarusuarios',item);
      },

      configurar_opciones_parametro(item){
        this.$emit('configurar_opciones',item);
      },

      /**podria servir, tal vez */
      filterOnlyCapsText (value, search, item) {
        /**value es el valor de la columna */
        /**search es el string de busqueda */
        /**item es el item actual */
        // console.log('value',value);
        // console.log('search',search);
        // console.log('item',item);
        // return value != null && search != null && typeof value === 'string'
        // && value.toString().indexOf(search) !== -1;
        if(search.includes(",")){
          console.log('mas de una palabra');
          let palabras = search.split(",");
          // console.log('palabras',palabras);
          return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLowerCase().indexOf(palabras[0]) !== -1 || value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLowerCase().indexOf(palabras[1]) !== -1
          // return true;
        }else{
          /**solo una palabra */
          return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLowerCase().indexOf(search) !== -1
        }
        
      },
    },
  }
</script>